import { useQuery } from '@tanstack/react-query';
import equityDividendService from "@equitySecurityDividendService";
import {useAuth} from "@/contexts/AuthContext.tsx";

const DEFAULT_PAGE_SIZE = 100;

/**
 * Fetches paginated dividend payments for a given equity security.
 *
 * @param equitySecurityId - The equity security ID to filter dividends by.
 * @param page - 1-indexed page number (default: 1).
 * @param pageSize - Number of records per page (default: 100).
 * @returns Query result containing `{ dividends, totalCount }`.
 */
export default function useFetchEquityDividends(
  equitySecurityId: string,
  page = 1,
  pageSize = DEFAULT_PAGE_SIZE
) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['equity-dividends', equitySecurityId, page, pageSize],
    queryFn: async () => {
      return await equityDividendService.fetchDividendsForEquity({
        userId: user.id,
        equitySecurityId,
        page,
      })
    },
    enabled: !!equitySecurityId,
  });
}
